import head from 'lodash/head';

export class GoogleLocationService {

    formatAddress(details) {
        let addressDetails = {
            serviceAreas: []
        };
        addressDetails.serviceAreas = details.address_components.reduce((serviceAreas, data) => {
            let type = head(data.types);
            let address = {
                type: '',
                name: ''
            };

            switch (type) {
                case 'country':
                    address.type = 'country';
                    address.name = data.short_name;
                    serviceAreas.push(address);
                    break;
                case 'administrative_area_level_1':
                    address.type = 'state';
                    address.name = data.short_name;
                    serviceAreas.push(address);
                    break;
                case 'administrative_area_level_2':
                    address.type = 'county';
                    address.name = data.long_name;
                    serviceAreas.push(address);
                    break;
                case 'administrative_area_level_3':
                    address.type = 'town';
                    address.name = data.long_name;
                    serviceAreas.push(address);
                    break;
                case 'locality':
                    address.type = 'village';
                    address.name = data.long_name;
                    serviceAreas.push(address);
                    break;
                case 'neighborhood':
                    address.type = 'township';
                    address.name = data.long_name;
                    serviceAreas.push(address);
                    break;
            };

            return serviceAreas;
        }, []);

        addressDetails.lat = details.geometry.location.lat();
        addressDetails.lng = details.geometry.location.lng();

        return addressDetails;
    }

    getLocationDetailsByPlaceName(placeName) {
        let geocoder = new google.maps.Geocoder();

        return new Promise((resolve, reject) => {
            geocoder.geocode({ 'address': placeName }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    resolve(results);
                } else {
                    reject('No results found');
                }
            });
        });
    }

};


// WEBPACK FOOTER //
// ./src/app/common/components/google-location/google-location.service.js